import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { config } from './config';


@Injectable({
  providedIn: 'root'
})
export class CubiculoService {
  user = [];
  constructor(private http: HttpClient) {
  }

  getData() {
    //return this.http.get('assets/json/Cubiculo.json');
    return this.http.get(config.apiUrl + '/Cubiculo/');
  }

  //Alta
  addData(data: undefined): Observable<any> {
    return this.http.post(config.apiUrl + '/Cubiculo/', data);
  }

  //Cambio
  updData(id: undefined, data: undefined): Observable<any> {
    return this.http.put(config.apiUrl + '/Cubiculo/' + id, data);
  }



}
